import { Box, Typography, Container, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import COLORS from '../../../../../../constants/colors';
import Logo from '../../../../../../assets/logo.png'; // Adjust the path based on your structure

const PrivacyPolicy = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1); // Navigates to the previous page
    };

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            {/* Logo */}
            <Box display="flex" justifyContent="center" mb={3}>
                <img src={Logo} alt="Yamba Africa Logo" style={{ height: 60 }} />
            </Box>

            {/* Paper Container without scrollability */}
            <Paper
                elevation={3}
                sx={{
                    p: 4,
                    backgroundColor: COLORS.background,
                    color: COLORS.text,
                    borderRadius: 2, // Soft edges
                    boxShadow: 0,
                }}
            >
                {/* Title */}
                <Typography variant="h4" fontWeight="bold" color={COLORS.primary} mb={3} textAlign="center">
                    Privacy Policy for Yamba Africa Ltd
                </Typography>

                <Typography variant="body2" mb={2} textAlign="center">
                    <strong>Effective Date:</strong> April 1st, 2025
                </Typography>

                <Typography variant="body2" mb={3}>
                    Yamba Africa Ltd, a subsidiary of Delvit Solutions Ltd, is dedicated to safeguarding the privacy of our users. 
                    This Privacy Policy details the collection, use, and protection of your personal information in alignment with Uganda's Data Protection and Privacy Act, 2019.
                </Typography>

                {/* Sections */}
                {[ 
                    {
                        title: '1. Information We Collect',
                        content: (
                            <>
                                We collect personal data directly from you when you:
                                <ul>
                                    <li><strong>Register an Account:</strong> We collect your name, email, phone number, and relevant contact details.</li>
                                    <li><strong>Create or Contribute to a Fundraiser:</strong> We gather information such as your name, contact details, and financial information necessary for processing transactions.</li>
                                    <li><strong>Contact Support:</strong> If you reach out to our support team at <a href="mailto:support@yambaafrica.com">support@yambaafrica.com</a>, we collect your contact information and relevant inquiry details.</li>
                                </ul>
                                Additionally, we may collect non-personal data, such as browser type, IP address, and device information, to enhance user experience and analyze service usage.
                            </>
                        ),
                    },
                    {
                        title: '2. Legal Basis for Processing',
                        content: (
                            <ul>
                                <li><strong>Consent:</strong> We obtain your explicit consent before collecting and processing your data.</li>
                                <li><strong>Contractual Necessity:</strong> Processing is essential to fulfill our contractual obligations.</li>
                                <li><strong>Legal Obligations:</strong> Compliance with legal requirements necessitates certain data processing activities.</li>
                            </ul>
                        ),
                    },
                    {
                        title: '3. Use of Information',
                        content: (
                            <ul>
                                <li>Provide and enhance services, including account management and fundraising operations.</li>
                                <li>Communicate with you regarding confirmations, updates, and inquiries.</li>
                                <li>Ensure compliance with legal obligations and enforce our terms of service.</li>
                            </ul>
                        ),
                    },
                    {
                        title: '4. Data Sharing and Disclosure',
                        content: (
                            <>
                                We do not sell your personal information. However, we may share your data with:
                                <ul>
                                    <li><strong>Service Providers:</strong> Trusted third parties who assist in platform operations, provided they adhere to confidentiality agreements.</li>
                                    <li><strong>Legal Authorities:</strong> When required to comply with legal obligations or to protect rights, property, or safety.</li>
                                </ul>
                            </>
                        ),
                    },
                    {
                        title: '5. Data Security',
                        content: 'We implement encryption, access controls, and secure storage practices to protect your personal data against unauthorized access, alteration, disclosure, or destruction.',
                    },
                    {
                        title: '6. Data Retention',
                        content: 'Personal data is retained only as long as necessary to fulfill operational and legal requirements. Afterward, it is securely deleted or anonymized.',
                    },
                    {
                        title: '7. Your Rights',
                        content: (
                            <>
                                You have the right to:
                                <ul>
                                    <li><strong>Access:</strong> Request confirmation and access to your data.</li>
                                    <li><strong>Rectification:</strong> Request correction of inaccurate or incomplete data.</li>
                                    <li><strong>Erasure:</strong> Request deletion of your personal data.</li>
                                    <li><strong>Objection:</strong> Object to data processing under certain circumstances.</li>
                                    <li><strong>Data Portability:</strong> Request transfer of your personal data to another service provider.</li>
                                </ul>
                                To exercise these rights, contact <a href="mailto:support@yambaafrica.com">support@yambaafrica.com</a>.
                            </>
                        ),
                    },
                    {
                        title: '8. International Data Transfers',
                        content: 'If personal data is transferred outside Uganda, we ensure compliance with equivalent data protection standards or obtain your explicit consent.',
                    },
                    {
                        title: '9. Cookies and Tracking Technologies',
                        content: 'Our platform uses cookies and similar technologies to enhance user experience. You can manage preferences through your browser settings.',
                    },
                    {
                        title: '10. Third-Party Links',
                        content: 'We are not responsible for external websites linked on our platform. Review their privacy policies before sharing personal data.',
                    },
                    {
                        title: '11. Changes to This Privacy Policy',
                        content: 'This policy may be updated periodically. Continued use of our services implies acceptance of the revised policy.',
                    },
                    {
                        title: '12. Contact Us',
                        content: (
                            <>
                                For inquiries, contact <a href="mailto:support@yambaafrica.com">support@yambaafrica.com</a>. We are committed to addressing concerns promptly.
                            </>
                        ),
                    },
                ].map((section, index) => (
                    <Box key={index} mt={4}>
                        <Typography variant="h6" fontWeight="bold" color={COLORS.primary} mb={2}>
                            {section.title}
                        </Typography>
                        <Typography variant="body2">{section.content}</Typography>
                    </Box>
                ))}

                {/* Back Button */}
                <Box mt={4} display="flex" justifyContent="left">
                    <Button variant="contained" color="primary" onClick={handleGoBack} sx={{
                        textTransform:'none',
                        borderRadius:4

                    }}>
                        Go Back
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};

export default PrivacyPolicy;
